import { FC } from 'react';
import cn from 'classnames';
import { BLOCKS, INLINES } from '@contentful/rich-text-types';

import { Block } from 'src/__generated__/graphqlTypes';
import { CommonRichText } from 'components/Shared/SharedComponents';
import { RichTextParsersConfig } from 'types/objectTypes';

import { CommonFooterInterface } from './declarations';
import styles from './Footer.module.scss';

const getParsersConfig = (): RichTextParsersConfig => ({
  [BLOCKS.PARAGRAPH]: {
    classNames: styles.paragraph,
  },
  [INLINES.HYPERLINK]: {
    classNames: styles.link,
  },
});

const OfferFooter: FC<CommonFooterInterface> = ({ footer }) => {
  if (!footer) {
    return null;
  }

  const offerData = footer.additionalCollection?.items
    ?.find((item) => item?.slug === 'offer' && item?.__typename === 'Block') as Block | undefined;

  if (!offerData) {
    return null;
  }

  return (
    <footer className={cn(styles.footer, styles.footerOffer)}>
      <CommonRichText
        content={offerData.content}
        parsersConfig={getParsersConfig()}
      />
      <span className={styles.hr} />
      <div className={styles.offerDetails}>
        <p className={cn(styles.paragraph)}>
          {offerData.title}
        </p>
        <p className={cn(styles.paragraph)}>
          {footer.copyrightDescription}
        </p>
      </div>
    </footer>
  );
};

export default OfferFooter;
